function enquiryTracking() {
    let brand = document.querySelector('.enquiry-form .js-enquiry-context');

    if(brand == null) {
        return;
    }

    if (brand.value === 'business-first-default') {
        businessFirstTracking();
    }
}

function businessFirstTracking() {
    let form = document.querySelector('.enquiry-form__form');

    form.addEventListener('submit', event => {
        event.preventDefault();

        gtag_report_conversion();

        fbq('track', 'Contact');

        event.target.submit();
    });
}

export default enquiryTracking;
